export const isTuple = (value: number[] | number) => {
  return Array.isArray(value) && value.length === 2;
};
